const _ = 0.4, O = 1, E = 0.85, T = 0.1, A = 2, I = "ROADMAP", o = 16, t = 5e-4, M = 24, c = 300, n = 3e3, s = 500, P = 500, D = 300, L = 1e3, N = 17, R = 10;
export {
  I as DEFAULT_MAP_TYPE,
  E as DEFAULT_OVERLAY_OPACITY,
  o as DEFAULT_ZOOM,
  N as INDOOR_VISIBILITY_ZOOM_THRESHOLD,
  t as INITIAL_BOUNDS_OFFSET,
  M as MAP_CONTROL_SIZE,
  c as MAP_DRAG_TIMEOUT,
  D as MAP_PINS_UPDATE_DEBOUNCE,
  L as MAP_TYPE_CHANGE_DEBOUNCE,
  A as MAX_FILE_SIZE_MB,
  O as MAX_OVERLAY_OPACITY,
  _ as MIN_OVERLAY_OPACITY,
  T as OPACITY_STEP,
  R as OUTDOOR_VISIBILITY_ZOOM_THRESHOLD,
  s as OVERLAY_MANIPULATION_TIMEOUT,
  P as TRANSFORM_UPDATE_DEBOUNCE,
  n as USER_INTERACTION_TIMEOUT
};
